import { render } from "./sectionStats.vue?vue&type=template&id=7f6244ba&scoped=true"
import script from "./sectionStats.vue?vue&type=script&lang=js"
export * from "./sectionStats.vue?vue&type=script&lang=js"

import "./sectionStats.vue?vue&type=style&index=0&id=7f6244ba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6244ba"]])

export default __exports__